import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import { Eye } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  BlogMidCTA,
  Eye,
  React
};